import { CRMAPIBase } from '@api/crmApiBase';
import { RegionListResp } from '@api/responseModels/regions/regionListResponse';
import { RegionResp } from '@api/responseModels/regions/regionResponse';
import { RequestResult } from '@api/responseModels/requestResult';
import { TRegion } from 'types/regions';

class RegionGroup extends CRMAPIBase {
    async getRegionList({
        page,
        per_page,
    }): Promise<RequestResult<RegionListResp>> {
        const result = await this.get<RegionListResp>(`/admin/regions`, {
            page,
            per_page,
        });
        return result;
    }

    async createRegion(params: TRegion): Promise<RequestResult<RegionResp>> {
        const result = await this.post<RegionResp>(`/admin/regions`, params);
        return result;
    }

    async updateRegion(
        id: number,
        params: TRegion,
    ): Promise<RequestResult<RegionResp>> {
        const result = await this.put<RegionResp>(`/admin/regions/${id}`, params);
        return result;
    }

    async deleteRegion(id: number): Promise<RequestResult<RegionResp>> {
        const result = await this.delete<RegionResp>(`/admin/regions/${id}`);
        return result;
    }
}

export { RegionGroup };
